const REST_API = 'https://api-skyniche-com.skyniche.website'
// const REST_API = 'http://localhost:4000'

module.exports={REST_API}